module.exports = __webpack_public_path__ + "static/img/hm_loop_card_02.8ea8519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/hm_loop_card_02.png
// module id = GuiZ
// module chunks = 1